import parsePhoneNumber, { AsYouType } from 'libphonenumber-js';

const DEFAULT_COUNTRY_CODE = 'US';

// `AsYouType.input` throws on anything but a string, and callers format values
// straight out of a GraphQL response where the field is nullable.
export const formatPhoneNumber = (
  phoneNumber,
  countryCode = DEFAULT_COUNTRY_CODE,
) => new AsYouType(countryCode).input(phoneNumber ?? '');

export const validatePhoneNumber = (
  number,
  countryCode = DEFAULT_COUNTRY_CODE,
  checkIsValid = false,
) => {
  try {
    const phoneNumber = parsePhoneNumber(number, countryCode);

    return checkIsValid ? phoneNumber.isValid() : phoneNumber.isPossible();
  } catch {
    // We just want to suppress the error
  }

  return false;
};
